export type CatalogSourceFilter = "all" | "ai" | "manual";

export const CATALOG_SOURCE_FILTER_OPTIONS: {
  value: CatalogSourceFilter;
  label: string;
  description: string;
}[] = [
  {
    value: "all",
    label: "All items",
    description: "Everything in the catalog, regardless of how it was added.",
  },
  {
    value: "ai",
    label: "From AI workout builder",
    description: "Only items the AI workout builder created automatically while generating sessions.",
  },
  {
    value: "manual",
    label: "Added by team",
    description: "Only items trainers or admins created, edited, or duplicated by hand.",
  },
];

export function catalogSourceFilterLabel(value: CatalogSourceFilter): string {
  return CATALOG_SOURCE_FILTER_OPTIONS.find((o) => o.value === value)?.label ?? "All items";
}

export function catalogSourceFilterDescription(value: CatalogSourceFilter): string {
  return CATALOG_SOURCE_FILTER_OPTIONS.find((o) => o.value === value)?.description ?? "";
}

export function matchesCatalogSourceFilter(
  aiGenerated: boolean | undefined,
  filter: CatalogSourceFilter
): boolean {
  if (filter === "all") return true;
  if (filter === "ai") return Boolean(aiGenerated);
  return !aiGenerated;
}
